import type { KpiCardSpec } from './card-spec';

/**
 * The Weekly active users scalar, shown on the Engagement page's Usage &
 * adoption section and the Users page's Active users section. One object in
 * two catalogs, so the two pages cannot report different figures.
 */
export const WEEKLY_ACTIVE_USERS_SCALAR_CARD: KpiCardSpec = {
    title: 'Weekly active users',
    source: 'login-activity',
    metric: 'weeklyActiveUsers',
    form: 'number',
    size: 'sm',
    description:
        "Users who signed in during the 7 days ending on the selected period's end date, counted once each, with a period-over-period delta.",
};
